import { actions } from './actions'

const initialState = {
  horariosEntregaMadrid: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
}

export default function horariosEntregaMadridReducer(state = initialState, action) {
  switch (action.type) {
    case actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_REQUESTED:
      return { ...state, horariosEntregaMadrid: { ...state.horariosEntregaMadrid, loading: true } }
    case actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_FILED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          loading: false,
          error: action.error,
        },
      }
    case actions.HORARIO_ENTREGA_MRW_UPDATE_REQUESTED:
      return {
        ...state,
        horariosEntregaMadrid: { ...state.horariosEntregaMadrid, loading: true, error: '' },
      }
    case actions.HORARIO_ENTREGA_MRW_UPDATE_SUCCEEDED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          reload: true,
          loading: false,
          error: '',
        },
      }
    case actions.HORARIO_ENTREGA_MRW_UPDATE_FILED:
      return {
        ...state,
        v: { ...state.horariosEntregaMadrid, loading: false, error: action.error },
      }
    case actions.HORARIO_ENTREGA_MRW_INSERT_REQUESTED:
      return {
        ...state,
        horariosEntregaMadrid: { ...state.horariosEntregaMadrid, loading: true, error: '' },
      }
    case actions.HORARIO_ENTREGA_MRW_INSERT_SUCCEEDED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          data: [].concat(action.payload, state.horariosEntregaMadrid.data),
          loading: false,
          error: '',
        },
      }
    case actions.HORARIO_ENTREGA_MRW_INSERT_FILED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          loading: false,
          error: action.error,
        },
      }
    case actions.HORARIO_ENTREGA_MRW_DELETE_REQUESTED:
      return {
        ...state,
        horariosEntregaMadrid: { ...state.horariosEntregaMadrid, loading: true, error: '' },
      }
    case actions.HORARIO_ENTREGA_MRW_DELETE_SUCCEEDED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          data: state.horariosEntregaMadrid.data.filter(
            horarioEntregaMadrid => horarioEntregaMadrid.horarioEntregaId !== action.payload,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.HORARIO_ENTREGA_MRW_DELETE_FILED:
      return {
        ...state,
        horariosEntregaMadrid: {
          ...state.horariosEntregaMadrid,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
